import { useState } from "react";
import { Link, NavLink } from "react-router-dom";
import { Menu, X, Phone } from "lucide-react";

const links = [
  { to: "/", label: "Home" },
  { to: "/about", label: "About" },
  { to: "/services", label: "Services" },
  { to: "/blog", label: "Blog" },
  { to: "/contact", label: "Contact" },
];

export default function Navbar() {
  const [open, setOpen] = useState(false);

  return (
    <header className="sticky top-0 z-40 bg-white/85 backdrop-blur border-b border-[color:var(--dh-line)]" data-testid="site-navbar">
      <div className="container-x flex items-center justify-between h-[72px]">
        <Link to="/" className="flex items-center gap-2.5" data-testid="brand-logo-link" aria-label="Digi Hub Solution — Home">
          <img src="/logo-256.png" alt="Digi Hub Solution" className="w-11 h-11 rounded-full object-cover shadow-sm ring-1 ring-black/5" />
          <div className="leading-tight hidden sm:block">
            <div className="font-display font-bold text-[color:var(--dh-navy)] text-[17px]">Digi Hub</div>
            <div className="text-[11px] tracking-[0.24em] font-semibold text-[color:var(--dh-orange)]">SOLUTION</div>
          </div>
        </Link>

        <nav className="hidden md:flex items-center gap-1">
          {links.map((l) => (
            <NavLink
              key={l.to}
              to={l.to}
              end={l.to === "/"}
              data-testid={`nav-link-${l.label.toLowerCase()}`}
              className={({ isActive }) =>
                `px-4 py-2 rounded-full text-[15px] font-semibold transition-colors ${
                  isActive ? "text-[color:var(--dh-orange)]" : "text-[color:var(--dh-navy)] hover:text-[color:var(--dh-orange)]"
                }`
              }
            >
              {l.label}
            </NavLink>
          ))}
        </nav>

        <div className="hidden md:flex items-center gap-3">
          <a href="tel:+919808724448" className="flex items-center gap-2 text-sm font-semibold text-[color:var(--dh-navy)]" data-testid="navbar-phone">
            <Phone className="w-4 h-4 text-[color:var(--dh-orange)]" />
            +91 98087 24448
          </a>
          <Link to="/contact" className="btn-primary text-sm" data-testid="navbar-cta">Get a Quote</Link>
        </div>

        <button className="md:hidden p-2" onClick={() => setOpen((v) => !v)} data-testid="mobile-menu-toggle" aria-label="menu">
          {open ? <X className="w-6 h-6" /> : <Menu className="w-6 h-6" />}
        </button>
      </div>

      {open && (
        <div className="md:hidden border-t border-[color:var(--dh-line)] bg-white" data-testid="mobile-menu">
          <div className="container-x py-4 flex flex-col gap-1">
            {links.map((l) => (
              <NavLink key={l.to} to={l.to} end={l.to === "/"} onClick={() => setOpen(false)} data-testid={`mobile-nav-${l.label.toLowerCase()}`}
                className={({ isActive }) => `px-3 py-3 rounded-lg font-semibold ${isActive ? "text-[color:var(--dh-orange)] bg-orange-50" : "text-[color:var(--dh-navy)]"}`}>
                {l.label}
              </NavLink>
            ))}
            <Link to="/contact" onClick={() => setOpen(false)} className="btn-primary mt-2 justify-center" data-testid="mobile-cta">Get a Quote</Link>
          </div>
        </div>
      )}
    </header>
  );
}
